/**
 * 上のバーの「Docs」（サイトのドキュメント・2026-10-26 console/docs-link・founder「ダッシュボードの上のバーに Docs のリンクを足して」）。
 * 純関数だけ（テストは docsLink.test.ts・画面は pages/ProjectsPage.tsx TopBar）。
 *
 * 行き先 = サイトの起点（ビルドの VITE_KUMO_SITE_URL）+ `/docs/`。ドメインは書かない（環境が変わってもコードを直さない）。
 * 値が無い・怪しい（safeHttpUrl が通さない）ときは null = リンクを出さない（webConnect.ts の siteUrl と同じ扱い）。
 *   WHY 出さないか: 壊れた行き先や javascript: の URL を押せる形で出すより、無い方がよい（ガイドは別にある）
 * ガイド（/guide）との違い: ガイド = ダッシュボードの中の短い案内。Docs = サイトの詳しいドキュメント（新しいタブで開く）
 */
import { safeHttpUrl } from './homeFlow.ts';

export function docsUrlFor(siteUrl: unknown): string | null {
  const site = safeHttpUrl(siteUrl); // 末尾の / は safeHttpUrl が落とす = `//docs/` にならない
  return site ? `${site}/docs/` : null;
}
